import WorkingHour from "app/models/workingHour"
import { Action, Types } from "./preferedHours.actions"

export type PreferedHoursState = {
  data: WorkingHour[] | undefined
  errors: {}
  loading: boolean
}

const initialState: PreferedHoursState = {
  data: undefined,
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): PreferedHoursState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PUT:
      return {
        ...state,
        loading: true,
      }

    case Types.PUT_SUCCESS: {
      const preferableWorkingHours = state.data || []
      const newPreferableWorkingHours = action.payload.data || []
      const updatedWeekdays = newPreferableWorkingHours.reduce(
        (weekdays: number[], currentWorkingHour: WorkingHour) => {
          const { weekday: currentWeekday } = currentWorkingHour
          if (weekdays.includes(currentWeekday)) return weekdays
          return [...weekdays, ...[currentWeekday]]
        },
        [],
      )

      const filteredWeekdayPreferableWorkingHours = preferableWorkingHours.filter(
        ({ weekday }) => !updatedWeekdays.includes(weekday),
      )
      const updatedWeekdayPreferableWorkingHours = [
        ...filteredWeekdayPreferableWorkingHours,
        ...newPreferableWorkingHours,
      ]

      return {
        ...state,
        data: updatedWeekdayPreferableWorkingHours,
        loading: false,
      }
    }

    case Types.PUT_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.DELETE:
      return {
        ...state,
        loading: true,
      }

    case Types.DELETE_SUCCESS: {
      if (!action.payload.data) return state
      const deletedIds = action.payload.data.map((deletedWorkingHour: WorkingHour) => deletedWorkingHour.id)
      const filteredDeletedPreferableWorkingHours =
        state.data?.filter((workingHour: WorkingHour) => !deletedIds.includes(workingHour.id)) || []

      return {
        ...state,
        loading: false,
        data: filteredDeletedPreferableWorkingHours,
      }
    }

    case Types.DELETE_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
